import jQuery from 'jquery';

(function($) {
 var self = null;
 var noOfDev;
    $.fn.changePosition = function( val,id ) {
        if(!self) return;
        var speed =val;
        if(speed > self.defaultProperty.maxVal) speed = self.defaultProperty.maxVal;
        if(speed < 0 || isNaN(speed)) speed = 0;
        var num = self.defaultProperty.numbers;
        var speedInDeg = self.defaultProperty.initDeg;
        var partVal = self.defaultProperty.maxDeg/(num.length-1);
        for(var j=0;j<=num.length;j++){
        var next = j+1;
        if(next === num.length) break;
          if(num[next] <= speed) {
             speedInDeg += partVal;
          }
          else{
          var dif = num[next]-num[j];
          var partdeg = partVal/dif;
          var balSpeed = speed - num[j];
         var balDeg = balSpeed * partdeg;
           speedInDeg += balDeg;
           break;
          }
        }
        self.parentElem.find(id).css({
        "transform" :'rotate('+speedInDeg+'deg)',
        "-webkit-transform" :'rotate('+speedInDeg+'deg)',
        "-moz-transform"    :'rotate('+speedInDeg+'deg)',
        "-o-transform"      :'rotate('+speedInDeg+'deg)'
        });

        var centerVal = (self.defaultProperty.speedNobes == 1) ? (speed * self.defaultProperty.multiplier).toFixed(2) : "";
        self.parentElem.find(".speedText").html(centerVal+"<br/><span class='speedTextInner'>"+self.defaultProperty.gagueLabel+"</span>" );

        /*for(var i=0; i<=noOfDev; i++){

            if(i%self.defaultProperty.noOfSmallDiv == 0){
                L.trace("villa--"+i);
                ci = i/self.defaultProperty.noOfSmallDiv;
                curIndVal = self.defaultProperty.numbers[ci];
            }else{
                var dif = self.defaultProperty.numbers[ci+1] && (self.defaultProperty.numbers[ci+1]-self.defaultProperty.numbers[ci]);
                curIndVal += dif/self.defaultProperty.noOfSmallDiv;
            }
            if(speed && (speed >= curIndVal)){
                self.parentElem.find(".envelope .nob").eq(i).addClass("bright");
                self.parentElem.find(".envelope .numb").eq(i).addClass("bright");
            }else{
                break;
            }
        }*/
       //  $(this).highlightNob(speed);
    };
    $.fn.highlightNob = function(speed) {
       //L.trace("highlightNob");
        var curIndVal = 0;
        var ci = 0;
        self.parentElem.find(".envelope .nob,.envelope .numb").removeClass("bright");
        if(!speed) return;
        for(var i=0; i<=noOfDev; i++){
            if(i%self.defaultProperty.noOfSmallDiv == 0){
                ci = i/self.defaultProperty.noOfSmallDiv;
                curIndVal = self.defaultProperty.numbers[ci];
                if(curIndVal == speed ) {
                    self.parentElem.find(".envelope .nob").eq(i).addClass("bright");
                    self.parentElem.find(".envelope .numb").eq(i).addClass("bright");
                    break;
                }
            }else{
                var next_main_nob_val = self.defaultProperty.numbers[ci+1] || self.defaultProperty.maxVal;
                if((curIndVal < speed) && (speed < next_main_nob_val) ){
                    var dif = next_main_nob_val - curIndVal;
                    var part_val = dif/self.defaultProperty.noOfSmallDiv;
                    var j = 1;
                    var next_nob_val = curIndVal+part_val;
                    while (next_nob_val <= speed) {
                        j++;
                        next_nob_val = curIndVal+(j*part_val);
                    }
                    var ind = i+(j-2);
                    self.parentElem.find(".envelope .nob").eq(ind).addClass("bright");
                    if(ind%self.defaultProperty.noOfSmallDiv == 0)
                        self.parentElem.find(".envelope .numb").eq(ind).addClass("bright");
                    break;
                }
            }
         }
    };

    $.fn.perform_speed_test = function( userPref ) {
        self = this;
        this.defaultProperty = {
            maxVal              : 100,         /**Max value of the meter*/
            divFact             : 10,          /**Division value of the meter*/
            dangerLevel         : 5,         /**more than this leval, color will be red*/
            goodLevel           : 100,         /**more than this leval, color will be red*/
            averageLevel        : 20,         /**more than this leval, color will be red*/
            initDeg             : -30,         /**reading begins angle*/
            maxDeg              : 240,         /**total angle of the meter reading*/
            edgeRadius          : 134,         /**radius of the meter circle*/
            speedNobeH          : 4,           /**speed nobe height*/
            speedoNobeW         : 75,          /**speed nobe width*/
            speedoNobeL         : 57,          /**speed nobe left position*/
            indicatorRadius     : 110,          /**radius of indicators position*/
            indicatorNumbRadius : 80,          /**radius of numbers position*/
            speedPositionTxtWH  : 100,            /**speedo-meter current value cont*/
            speedPositionTxtH  : 80,             /**speedo-meter current value cont*/
            speednobCenter      : 18,          /**speedo-meter center*/
             nobW                : 20,          /**indicator nob width*/
             nobH                : 2,           /**indicator nob height*/
             numbW               : 50,          /**indicator number width*/
             numbH               : 23,          /**indicator number height*/
             midNobW             : 10,          /**indicator mid nob width*/
             midNobH             : 1,           /**indicator mid nob height*/
            noOfSmallDiv        : 5,           /**no of small div between main div*/
            multiplier          : 1,	       /**Center value multiplier e.g. 1 x 1000 RPM*/
            gagueLabel: 'Mbps',     /**Label on guage Face*/
            speedNobes      : 3,
			capabilities    :[]
        };
    var indicator_numbers_length = userPref.numbers && userPref.numbers.length || 0;
    if(indicator_numbers_length) this.defaultProperty.goodLevel = userPref.numbers[indicator_numbers_length-1];
    if(typeof userPref === 'object') for (var prop in userPref) this.defaultProperty[prop] = userPref[prop];
    noOfDev = (this.defaultProperty.numbers.length-1)* this.defaultProperty.noOfSmallDiv;
    var divDeg = this.defaultProperty.maxDeg/noOfDev,
        speedoWH = this.defaultProperty.edgeRadius*2,
        speedNobeTop = this.defaultProperty.edgeRadius - this.defaultProperty.speedNobeH/2,
        speedNobeAngle = this.defaultProperty.initDeg,
        speednobCenterTl = this.defaultProperty.edgeRadius - this.defaultProperty.speednobCenter/2,
        speedPositionTxtTL = this.defaultProperty.edgeRadius - this.defaultProperty.speedPositionTxtWH/2,
        tempDiv = '<div class="eInner envelope-border"></div>',
        induCatorLinesPosLeft,induCatorLinesPosTop,induCatorNumbPosLeft,induCatorNumbPosTop;
    this.setCssProperty = function(){
        var tempStyleVar = [
          '<style>',
            '#' + this.parentElemId + ' .envelope{',
              'width  :'+ convert_to_rem(speedoWH) + 'rem;',
              'height :'+ convert_to_rem(speedoWH) + 'rem;',
            '}',
             '#' + this.parentElemId + ' .eInner{',
              'width  :'+ convert_to_rem(speedoWH-20) + 'rem;',
              'height :'+ convert_to_rem(speedoWH-20) + 'rem;',
              '}',
            '#' + this.parentElemId + ' .speedPosition{',
              'width  :'+convert_to_rem(this.defaultProperty.speednobCenter) + 'rem;',
              'height :'+convert_to_rem(this.defaultProperty.speednobCenter) + 'rem;',
              'top  :'+convert_to_rem(speednobCenterTl) + 'rem;',
              'left :'+convert_to_rem(speednobCenterTl) + 'rem;',
            '}',
            '#' + this.parentElemId + ' .speedText{',
              'width  :'+convert_to_rem(this.defaultProperty.speedPositionTxtWH) + 'rem;',
              'height :'+convert_to_rem(this.defaultProperty.speedPositionTxtH) + 'rem;',
              'bottom  : 2rem;',
              'left :'+convert_to_rem(speedPositionTxtTL) + 'rem;',
            '}',
            '#' + this.parentElemId + ' .speedNobe div{',
              'width  :'+ convert_to_rem(this.defaultProperty.speedoNobeW) + 'rem;',
              'left :'+ convert_to_rem(this.defaultProperty.speedoNobeL) + 'rem;',
            '}',
            '#' + this.parentElemId + ' .nob{',
              'width  :'+ convert_to_rem(this.defaultProperty.nobW) + 'rem;',
              'height :'+ convert_to_rem(this.defaultProperty.nobH)+ 'rem;',
            '}',
            '#' + this.parentElemId + ' .numb{',
              'width  :'+ convert_to_rem(this.defaultProperty.numbW) + 'rem;',
              'height :'+ convert_to_rem(this.defaultProperty.numbH) + 'rem;',
            '}',
           '#' + this.parentElemId + ' .midNob{',
              'width  :'+ convert_to_rem(this.defaultProperty.midNobW) + 'rem;',
              'height :'+ convert_to_rem(this.defaultProperty.midNobH) + 'rem;',
            '}',
            '#' + this.parentElemId + ' .speedNobe{',
              'height            :'+ convert_to_rem(this.defaultProperty.speedNobeH) + 'rem;',
              'top               :'+ convert_to_rem(speedNobeTop) + 'rem;',
              'transform         :rotate('+speedNobeAngle+'deg);',
              '-webkit-transform :rotate('+speedNobeAngle+'deg);',
              '-moz-transform    :rotate('+speedNobeAngle+'deg);',
              '-o-transform      :rotate('+speedNobeAngle+'deg);',
            '}',
          '</style>',
        ].join('');
        this.parentElem.append(tempStyleVar);
    };

    this.creatHtmlsElecments = function(){
        this.parentElemId = $(this).attr('id');
        $("#"+ this.parentElemId).empty();
        this.parentElem = $(this);
        this.setCssProperty();
        this.createIndicators();
    };
    function convert_to_rem(m){
        return (m/16);
    }
    this.createIndicators = function(){
        //var Indlevel = "";
        var cv= 0;
        var speedCls = "";
        for(var i=0; i<=noOfDev; i++){
        var curDig = this.defaultProperty.initDeg + i*divDeg;
        var curIndVal = "";
        if(i%this.defaultProperty.noOfSmallDiv == 0){
            cv = i/this.defaultProperty.noOfSmallDiv;
            curIndVal = this.defaultProperty.numbers[cv];
        }
          var induCatorLinesPosY = this.defaultProperty.indicatorRadius * Math.cos( 0.01746 * curDig);
          var induCatorLinesPosX = this.defaultProperty.indicatorRadius * Math.sin( 0.01746 * curDig);

          var induCatorNumbPosY = this.defaultProperty.indicatorNumbRadius * Math.cos( 0.01746 * curDig);
          var induCatorNumbPosX = this.defaultProperty.indicatorNumbRadius * Math.sin( 0.01746 * curDig);

          var tempDegInd;
          if(i%this.defaultProperty.noOfSmallDiv == 0){
            induCatorLinesPosLeft = (this.defaultProperty.edgeRadius - induCatorLinesPosX )-2;
            induCatorLinesPosTop = (this.defaultProperty.edgeRadius - induCatorLinesPosY)-10;
            tempDegInd = [
                      'transform         :rotate('+curDig+'deg)',
                      '-webkit-transform :rotate('+curDig+'deg)',
                      '-o-transform      :rotate('+curDig+'deg)',
                      '-moz-transform    :rotate('+curDig+'deg)',
                    ].join(";");
            tempDiv += '<div class="nob '+speedCls+'" style="left:'+convert_to_rem(induCatorLinesPosTop)+'rem;top:'+convert_to_rem(induCatorLinesPosLeft)+'rem;'+tempDegInd+'"></div>';
            induCatorNumbPosLeft = ((this.defaultProperty.edgeRadius - induCatorNumbPosX) - (this.defaultProperty.numbW/2))+12;
            induCatorNumbPosTop = ((this.defaultProperty.edgeRadius - induCatorNumbPosY) - (this.defaultProperty.numbH/2))-15;
            tempDiv += '<div class="numb '+speedCls+'" style="left:'+ convert_to_rem(induCatorNumbPosTop) +'rem;top:'+convert_to_rem(induCatorNumbPosLeft)+'rem;">'+ curIndVal +'</div>';
          }else{
            induCatorLinesPosLeft = (this.defaultProperty.edgeRadius - induCatorLinesPosX )-(this.defaultProperty.midNobH/2);
            induCatorLinesPosTop = (this.defaultProperty.edgeRadius - induCatorLinesPosY)-(this.defaultProperty.midNobW/2);
            tempDegInd = [
                      'transform         :rotate('+curDig+'deg)',
                      '-webkit-transform :rotate('+curDig+'deg)',
                      '-o-transform      :rotate('+curDig+'deg)',
                      '-moz-transform    :rotate('+curDig+'deg)',
                    ].join(";");
            tempDiv += '<div class="nob '+speedCls+' midNob" style="left:'+convert_to_rem(induCatorLinesPosTop)+'rem;top:'+convert_to_rem(induCatorLinesPosLeft)+'rem;'+tempDegInd+'"></div>';
            tempDiv += '<div class="numb"></div>';
          }
        }
        this.parentElem.append('<div class="envelope">');
        var speedNobe="";
        var nobe_id = this.defaultProperty.capabilities;
        for(var n=0; n<nobe_id.length; n++) speedNobe += '<div id="dial_hand_'+nobe_id[n]+'" class="speedNobe"><div></div></div>';
        speedNobe += '<div class="speedPosition"></div><div class="speedText"></div>';
        this.parentElem.find(".envelope").append(speedNobe+tempDiv);
      };
        this.creatHtmlsElecments();
    };
}(jQuery));
/* vim:set ts=8 sw=2 expandtab: */
